import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ, API_TYPE_NIRVANA } from '../../webcomponents.constants';
import {
  PhasrApplyActionPanelBaseDataProvider
} from '../dataProvider/PhasrApplyActionPanelBaseDataProvider';

export class PhasrApplyActionPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PhasrApplyActionPanelBaseDataProvider);
  }
}
